// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"4d40c6b3","101":"82dceb52","156":"b1d49cb4","166":"62e310b2","178":"48e95fe9","481":"9b1e863e","638":"f1fe39f8","640":"e8a30781","899":"34ce1489"}[chunkId] + ".chunk.js";
};